module.exports = __webpack_public_path__ + "static/media/ic_export.6373c280.svg";